/* eslint-disable */
import { defineNuxtPlugin } from '#app'
import CryptoJS from 'crypto-js'

const skey = "zthxw34cdp6wfyxmpad38v52t3hsz6c5"

const CryptoJSAesJson = {
  stringify: function (cipherParams: any) {
    var j = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) };
    if (cipherParams.iv) j.iv = cipherParams.iv.toString();
    if (cipherParams.salt) j.s = cipherParams.salt.toString();
    return JSON.stringify(j);
  },
  parse: function (jsonStr: string) {
    var j = JSON.parse(jsonStr);
    var cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext: CryptoJS.enc.Base64.parse(j.ct) });
    if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv)
    if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s)
    return cipherParams;
  }
}

function safe_b64encode(string: string) {
  let data = btoa(string);
  data = data.replace('+', '-')
  data = data.replace('/', '_')
  data = data.replace('=', '')
  return data;
}

function safe_b64decode(string: string) {
  let data = string.replace('-', '+')
  data = data.replace('_', '/')
  const mod4 = data.length % 4
  if (mod4) {
    data += '===='.substr(mod4)
  }
  return atob(data);
}

export default defineNuxtPlugin((nuxtApp) => {
  return {
    provide: {
      encode: (value: any, key?: string) => {
        if (!value) {
          return false
        }
        const crypttext = CryptoJS.AES.encrypt(JSON.stringify(value), key || skey, { format: CryptoJSAesJson }).toString()
        return safe_b64encode(crypttext).trim()
      },
      decode: (value: string) => {
        if (!value) {
          return false
        }
        const crypttext = safe_b64decode(value)
        const decrypttext = JSON.parse(CryptoJS.AES.decrypt(crypttext, skey, { format: CryptoJSAesJson }).toString(CryptoJS.enc.Utf8))
        return decrypttext.trim()
      }
    }
  }
})
